export const MainMenuData = [
  {
    id: 1,
    submenu: false,
    title: "cat",
    handle: "/equipment/cat/",
    sub: [],
  },
  {
    id: 2,
    submenu: false,
    title: "sem",
    handle: "/equipment/sem/",
    sub: [],
  },
  {
    id: 3,
    submenu: false,
    title: "generator",
    handle: "/equipment/generator/",
    sub: [],
  },
  {
    id: 4,
    submenu: false,
    title: "rent",
    handle: "/rent",
  },
  {
    id: 5,
    submenu: false,
    title: "other",
    handle: "/equipment/other/",
  },
];
